import { createContext } from 'react';
var EventEmitterContext = /*#__PURE__*/createContext(null);
export default EventEmitterContext;